import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
export default ({ data }) => {
  console.log(data)
return (
    <Layout>
      <div>
        <h1>My Products</h1>
        <table id="hometable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Images</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {data.allBigCommerceNode.edges.map(({ node }, index) => (
              <tr key={index}>
                <td class="homeName"><a href={`${node.custom_url.url}`}>{node.name}</a></td>
                <td class="homeDesc"><div dangerouslySetInnerHTML={{__html: node.description}}></div></td>
<td>
                {node.images.map(({url_thumbnail}, index) =>(
                    <img class="pthumb" key={index} src={url_thumbnail}/>
                    ))}
                </td>

                <td class="homePrice">${node.price.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  )
}
export const query = graphql`
query {
    allBigCommerceNode {
      edges {
        node {
          images {
            url_thumbnail
          }
          description
          name
          price
          custom_url{
            url
          }
        }
      }
    }
  }
`
